import { Page } from "@/models/page-models/Page";

export const PoPayments: Page = {
  "path": "po-payments",
  "name": "PO Payments",
  "props": {
    "data": {
      "title": "PO Payments",
      "printable": "FALSE",
      "url": "po-payments",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedPoId",
                  "label": "Select Purchase Order",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "copySelectedPoData"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.POs.data",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,purchaseOrder,{{__item}})"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.selectedPoData.supplier.name",
                  "label": "Supplier",
                  "showIf": "{{fetchedData.selectedPoId}}"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "table",
                  "label": "PO Table",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedPoId}}",
                  "items": "fetchedData.selectedPoData.purchasedRMs",
                  "tableType": "static",
                  "showActions": false,
                  "headers": [
                    {
                      "value": "__item.rawMaterial",
                      "text": "Material Descirptions",
                      "formula": "fn(HELPER_FN,goodsName,{{__item.rawMaterial}})"
                    },
                    {
                      "value": "__item.rawMaterial.rawMaterialUnit",
                      "text": "Unit"
                    },
                    {
                      "value": "__item.unitQuantity",
                      "text": "Quantity"
                    },
                    {
                      "value": "__item.unitPrice",
                      "text": "Unit Price SAR",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.unitPrice}})"
                    },
                    {
                      "value": "__item.total",
                      "text": "Total SAR",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,{{{{__item.unitQuantity}} * {{__item.unitPrice}}}})"
                    },
                    {
                      "value": "__item.VAT",
                      "text": "Vat @ {{fetchedData.companyDetails.data.0.data.vatPercentage}}%",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,fn(MULTIPLY,{{fetchedData.companyDetails.data.0.data.vatPercentage}},0.01,{{__item.unitQuantity}},{{__item.unitPrice}}))"
                    },
                    {
                      "value": "__item.totalPrice",
                      "text": "Total Price SAR",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,fn(MULTIPLY,fn(SUM,fn(MULTIPLY,{{fetchedData.companyDetails.data.0.data.vatPercentage}},0.01),1),{{__item.unitQuantity}},{{__item.unitPrice}}))"
                    }
                  ]
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Total Quantity",
                  "unit": "KG",
                  "showIf": "{{fetchedData.selectedPoId}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,numFormat,fn(ARRAY_SUM,{{__item.unitQuantity}},{{fetchedData.selectedPoData.purchasedRMs}}))"
                },
                {
                  "type": "label",
                  "label": "Total Amount",
                  "showIf": "{{fetchedData.selectedPoId}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,currency,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,fn(SUM,fn(MULTIPLY,{{fetchedData.companyDetails.data.0.data.vatPercentage}},0.01),1),{{__arrayItem.unitQuantity}},{{__arrayItem.unitPrice}}),{{fetchedData.selectedPoData.purchasedRMs}},_id))"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.type",
                  "label": "type",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedPoId}}",
                  "items": "[\"Cheque Payment Voucher\",\"Dammam Journal Voucher\",\"Cash Payment Voucher\",\"Receipt Voucher\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.dueDate",
                  "label": "Due Date",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedPoId}}"
                },
                {
                  "type": "input",
                  "variable": "formData.supplierInvoiceNumber",
                  "label": "Supplier Invoice #",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedPoId}}"
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.debitCredit",
                  "label": "Debit/Credit",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedPoId}}",
                  "items": "[\"Debit\",\"Credit\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "formData.value",
                  "label": "Amount",
                  "unit": "SAR",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedPoId}}"
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.description",
                  "label": "Description",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedPoId}}"
                }
              ]
            },
            {
              "name": "8",
              "pageItems": [
                {
                  "type": "checkbox",
                  "variable": "formData.paymentComplete",
                  "label": "Mark as Payment Complete",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedPoId}}"
                }
              ]
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Submit Payment",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "submitPoPayment"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedPoId}}",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getPOsWithPendingPayments"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCompanyDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=company-detail",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.companyDetails"
        },
        "name": "getCompanyDetails"
      }
    ],
    "functions": [
      {
        "name": "submitPoPayment",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/{{fetchedData.selectedPoId}}/payment",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "getPOsWithPendingPayments",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/pending-payment",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.POs"
      },
      {
        "name": "copySelectedPoData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedPoData"
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE",
  "visible": false
}